let lastCategoryInput = {};

const getCachedUserInput = (blockCategory) => lastCategoryInput[blockCategory] || '';

const setCachedUserInput = (blockCategory, userInput) => {
  lastCategoryInput = {
    [blockCategory]: userInput,
  };
};

const clearCachedUserInput = () => {
  lastCategoryInput = {};
};

export { getCachedUserInput, setCachedUserInput, clearCachedUserInput };
